module.exports = __webpack_public_path__ + "static/forecast-b87b9eb5f6c72576068fa5711263fe9e.jpg";